module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0156.jpg?v=6d5ee465";